import React, { Component } from "react";
import Dashboard from "./components/dashboard";
import { Route, Redirect, Switch } from "react-router-dom";
import NotFound from "./components/notfound";

import Navigation from "./components/common/navigation";
import LoginForm from "./components/loginForm";

import Companies from "./components/company/companies";
import CompanyForm from "./components/company/companyForm";
import CompanyEditForm from "./components/company/companyEditForm";
import CompanyEditManagerForm from "./components/company/companyManagerEditForm";

import RoomTypes from "./components/room_ledger_type/types";
import RoomTypeForm from "./components/room_ledger_type/typeForm";
import RoomTypeEditForm from "./components/room_ledger_type/typeEditForm";

import VehicleTypes from "./components/vehicle_ledger_type/types";
import VehicleTypeForm from "./components/vehicle_ledger_type/typeForm";
import VehicleTypeEditForm from "./components/vehicle_ledger_type/typeEditForm";

import VisaTypes from "./components/visa_ledger_type/types";
import VisaTypeForm from "./components/visa_ledger_type/typeForm";
import VisaTypeEditForm from "./components/visa_ledger_type/typeEditForm";

import YardTypes from "./components/yard_ledger_type/types";
import YardTypeForm from "./components/yard_ledger_type/typeForm";
import YardTypeEditForm from "./components/yard_ledger_type/typeEditForm";

import ExpenseTypes from "./components/expense_type/types";
import ExpenseTypeForm from "./components/expense_type/typeForm";
import ExpenseTypeEditForm from "./components/expense_type/typeEditForm";

import Rooms from "./components/room/rooms";
import RoomForm from "./components/room/form";
import RoomEditForm from "./components/room/editForm";
import RoomDetail from "./components/room/detail";
import RoomLedgerEditForm from "./components/room/editLedger";

import Projects from "./components/project/projects";
import ProjectForm from "./components/project/form";
import ProjectEditForm from "./components/project/editForm";
import ProjectDetail from "./components/project/detail";
import ProjectLedgerEditForm from "./components/project/editLedger";
import ProjectLedgerDocumentForm from "./components/project/addLedgerDocument";

import Accounts from "./components/account/accounts";
import AccountForm from "./components/account/form";
import AccountEditForm from "./components/account/editForm";
import AccountDetail from "./components/account/detail";
import AccountLedgerEditForm from "./components/account/editLedger";
import AccountDocumentForm from "./components/account/addDocument";
import AccountDocumentEditForm from "./components/account/editDocument";

import PrivateAccounts from "./components/private_account/accounts";
import PrivateAccountForm from "./components/private_account/form";
import PrivateAccountEditForm from "./components/private_account/editForm";
import PrivateAccountDetail from "./components/private_account/detail";
import PrivateAccountLedgerEditForm from "./components/private_account/editLedger";
import PrivateAccountDocumentForm from "./components/private_account/addDocument";
import PrivateAccountDocumentEditForm from "./components/private_account/editDocument";

import Invoices from "./components/invoice/invoices";
import InvoiceForm from "./components/invoice/form";
import InvoiceEditForm from "./components/invoice/editForm";
import InvoiceDetail from "./components/invoice/detail";

import Cheques from "./components/pdcreceived/cheques";
import ReceivedChequeForm from "./components/pdcreceived/form";
import ReceivedChequeEditForm from "./components/pdcreceived/editForm";
import ReceivedChequeDetail from "./components/pdcreceived/detail";

import PCheques from "./components/pdcpaid/cheques";
import PaidChequeForm from "./components/pdcpaid/form";
import PaidChequeEditForm from "./components/pdcpaid/editForm";
import PaidChequeDetail from "./components/pdcpaid/detail";

import LedgerTypes from "./components/ledger_type/types";
import LedgerTypeForm from "./components/ledger_type/typeForm";
import LedgerTypeEditForm from "./components/ledger_type/typeEditForm";

import PrivateLedgerTypes from "./components/private_ledger_type/types";
import PrivateLedgerTypeForm from "./components/private_ledger_type/typeForm";
import PrivateLedgerTypeEditForm from "./components/private_ledger_type/typeEditForm";

import Vehicles from "./components/vehicle/vehicles";
import VehicleForm from "./components/vehicle/form";
import VehicleEditForm from "./components/vehicle/editForm";
import VehicleDetail from "./components/vehicle/detail";
import VehicleDocumentForm from "./components/vehicle/addDocument";
import VehicleDocumentEditForm from "./components/vehicle/editDocument";
import VehicleLedgerEditForm from "./components/vehicle/editLedger";

import Expenses from "./components/expense/expenses";
import ExpenseForm from "./components/expense/form";
import ExpenseEditForm from "./components/expense/editForm";

import Yards from "./components/yard/yards";
import YardForm from "./components/yard/form";
import YardEditForm from "./components/yard/editForm";
import YardDetail from "./components/yard/detail";
import YardLedgerEditForm from "./components/yard/editLedger";

import Visas from "./components/visa/visas";
import VisaForm from "./components/visa/form";
import VisaEditForm from "./components/visa/editForm";
import VisaDetail from "./components/visa/detail";

import VisaInOutDetail from "./components/visa/inOutDetail";

import VisaDocumentForm from "./components/visa/addDocument";
import VisaLedgerEditForm from "./components/visa/editLedger";

import VisaLedgerDocumentForm from "./components/visa/addLedgerDocument";
import VehicleLedgerDocumentForm from "./components/vehicle/addLedgerDocument";
import AccountLedgerDocumentForm from "./components/account/addLedgerDocument";
import PrivateAccountLedgerDocumentForm from "./components/private_account/addLedgerDocument";

import YardLedgerDocumentForm from "./components/yard/addLedgerDocument";
import RoomLedgerDocumentForm from "./components/room/addLedgerDocument";

import VisaDocumentEditForm from "./components/visa/editDocument";

import ProjectDocumentForm from "./components/project/addDocument";
import ProjectDocumentEditForm from "./components/project/editDocument";

//import PrintDocument from "./components/visa/printDocument";

import Banks from "./components/bank/banks";
import BankForm from "./components/bank/form";
import BankEditForm from "./components/bank/editForm";

import CompanyDocuments from "./components/company_document/documents";
import CompanyDocumentForm from "./components/company_document/form";
import CompanyDocumentEditForm from "./components/company_document/editForm";

import Users from "./components/user/users";
import UserForm from "./components/user/userForm";
import UserEditForm from "./components/user/userEditForm";

import Salaries from "./components/salary/types";
import SalaryForm from "./components/salary/typeForm";
import SalaryEditForm from "./components/salary/typeEditForm";
import SalaryDetail from "./components/salary/detail";

//reports
import SalaryReport from "./components/report/salary";
import ProjectSalaryReport from "./components/report/projectsalary";
import IncomeReport from "./components/report/income";
import ScrapReport from "./components/report/scrap";
import Reports from "./components/report/reports";

import JVReport from "./components/report/jv";
import ReceiveableReport from "./components/report/receiveable";
import PayableReport from "./components/report/payable";

import VehicleReport from "./components/report/vehicle";
import VisaReport from "./components/report/visa";
import YardReport from "./components/report/yard";
import RoomReport from "./components/report/room";
import GeneralLedgerReport from "./components/report/generalledger";
import PassportInOutReport from "./components/report/passportinout";
import GeneralLedgerEntry from "./components/report/generalledgerentry";

import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import "react-block-ui/style.css";
import "./App.css";
import Logout from "./components/logout";
import auth from "./services/authService";
import ProtectedRoute from "./components/common/protectedRoute";
import { CommentActions, Container } from "semantic-ui-react";

import MonthlRoomReport from "./components/montly_report/room";
import MonthlVehicleReport from "./components/montly_report/vehicle";
import MonthlYardReport from "./components/montly_report/yard";
import MonthlVisaReport from "./components/montly_report/visa";
import VehicleExpiryReport from "./components/report/vehicleexpiry";

import DocumentsExpiryReport from "./components/report/documentexpiry";

import VisaExpiryReport from "./components/report/visaexpiry";
import PassportExpiryReport from "./components/report/passportexpiry";

import InvoicesReport from "./components/report/invoices";
import PDCPaidReport from "./components/report/pdcpaid";
import PDCReceivedReport from "./components/report/pdcreceived";

import ProjectsReport from "./components/report/projects";

// Web Part
import Contacts from "./components/web_contact/contacts";
import ContactForm from "./components/web_contact/form";
import ContactEditForm from "./components/web_contact/editForm";

// Tour Part
import Tours from "./components/web_tour/tours";
import TourForm from "./components/web_tour/form";
import TourEditForm from "./components/web_tour/editForm";

// Contributers Part
import Contributers from "./components/web_contributer/contributers";
import ContributerForm from "./components/web_contributer/form";
import ContributerEditForm from "./components/web_contributer/editForm";

// Villages Part
import Villages from "./components/web_village/villages";
import VillageForm from "./components/web_village/form";
import VillageEditForm from "./components/web_village/editForm";

// News Part
import News from "./components/web_news/news";
import NewsForm from "./components/web_news/form";
import NewsEditForm from "./components/web_news/editForm";

// Pages Part
import Pages from "./components/web_page/pages";
import PageForm from "./components/web_page/form";
import PageEditForm from "./components/web_page/editForm";

// Photos Part
import Photos from "./components/web_photo/photos";
import PhotoForm from "./components/web_photo/form";
import PhotoEditForm from "./components/web_photo/editForm";

// Teachers Part
import Teachers from "./components/web_teacher/teachers";
import TeacherForm from "./components/web_teacher/form";
import TeacherEditForm from "./components/web_teacher/editForm";

import Categories from "./components/category/categories";
import CategoryForm from "./components/category/categoryForm";
import CategoryEditForm from "./components/category/categoryEditForm";

import SupplierItems from "./components/supplier_item/supplierItems";
import SupplierItemForm from "./components/supplier_item/supplierItemForm";
import SupplierItemEditForm from "./components/supplier_item/supplierItemEditForm";
import SupplierItemDetail from "./components/supplier_item/supplierItemDetail";

class App extends Component {
  state = {};
  componentDidMount() {
    const user = auth.getCurrentUser();
    this.setState({ user });
  }
  render() {
    const { user } = this.state;

    return (
      <React.Fragment>
        {user && <Navigation user={user} />}
        <ToastContainer />

        <Container style={{ marginTop: "2em", width: "96%" }}>
          <Switch>
            <ProtectedRoute
              path="/dashboard/:outlet"
              exact
              component={Dashboard}
            />
            <ProtectedRoute path="/dashboard" component={Dashboard} />
            <ProtectedRoute
              exact
              path="/yards-accounts/view/:id"
              component={YardDetail}
            />
            <ProtectedRoute
              exact
              path="/yards-accounts/:id/document/new/:ledger"
              component={YardLedgerDocumentForm}
            />
            {/* expenses entreis */}
            <ProtectedRoute
              exact
              path="/expenses/:id"
              component={ExpenseForm}
            />
            <ProtectedRoute
              exact
              path="/expenses/:id/edit"
              component={ExpenseEditForm}
            />
            <ProtectedRoute path="/expenses" component={Expenses} />
            {/* Monyhly reports */}
            <ProtectedRoute
              exact
              path="/report/monthly/room"
              component={MonthlRoomReport}
            />
            <ProtectedRoute
              exact
              path="/report/monthly/vehicle"
              component={MonthlVehicleReport}
            />
            <ProtectedRoute
              exact
              path="/report/monthly/yard"
              component={MonthlYardReport}
            />
            <ProtectedRoute
              exact
              path="/report/monthly/visa"
              component={MonthlVisaReport}
            />
            {/* expenses */}
            <ProtectedRoute
              exact
              path="/expense-types/:id"
              component={ExpenseTypeForm}
            />
            <ProtectedRoute
              path="/expense-types/:id/edit"
              component={ExpenseTypeEditForm}
            />
            <ProtectedRoute path="/expense-types" component={ExpenseTypes} />

            {/* categories */}
            <ProtectedRoute
              exact
              path="/categories/:id"
              component={CategoryForm}
            />
            <ProtectedRoute
              path="/categories/:id/edit"
              component={CategoryEditForm}
            />
            <ProtectedRoute path="/categories" component={Categories} />
            {/* items */}
            <ProtectedRoute
              exact
              path="/items/:id"
              component={SupplierItemForm}
            />
            <ProtectedRoute
              exact
              path="/items/:id/edit"
              component={SupplierItemEditForm}
            />
            <ProtectedRoute
              exact
              path="/items/view/:id"
              component={SupplierItemDetail}
            />
            <ProtectedRoute exact path="/items" component={SupplierItems} />

            {/* other accounts */}
            <ProtectedRoute
              exact
              path="/accounts/:id/document/new/"
              component={AccountDocumentForm}
            />
            <ProtectedRoute
              exact
              path="/accounts/:id/document/new/:ledger"
              component={AccountLedgerDocumentForm}
            />
            <ProtectedRoute
              exact
              path="/accounts-documents/:id/edit"
              component={AccountDocumentEditForm}
            />
            <ProtectedRoute
              exact
              path="/accounts-ledgers/:id/edit"
              component={AccountLedgerEditForm}
            />
            <ProtectedRoute
              exact
              path="/accounts/view/:id"
              component={AccountDetail}
            />
            <ProtectedRoute
              exact
              path="/accounts/:id"
              component={AccountForm}
            />
            <ProtectedRoute
              path="/accounts/:id/edit"
              component={AccountEditForm}
            />
            <ProtectedRoute path="/accounts" component={Accounts} />
            {/* private accounts */}
            <ProtectedRoute
              exact
              path="/private-accounts/:id/document/new/"
              component={PrivateAccountDocumentForm}
            />
            <ProtectedRoute
              exact
              path="/private-accounts/:id/document/new/:ledger"
              component={PrivateAccountLedgerDocumentForm}
            />
            <ProtectedRoute
              exact
              path="/private-accounts-documents/:id/edit"
              component={PrivateAccountDocumentEditForm}
            />
            <ProtectedRoute
              exact
              path="/private-accounts-ledgers/:id/edit"
              component={PrivateAccountLedgerEditForm}
            />
            <ProtectedRoute
              exact
              path="/private-accounts/view/:id"
              component={PrivateAccountDetail}
            />
            <ProtectedRoute
              exact
              path="/private-accounts/:id"
              component={PrivateAccountForm}
            />
            <ProtectedRoute
              path="/private-accounts/:id/edit"
              component={PrivateAccountEditForm}
            />
            <ProtectedRoute
              path="/private-accounts"
              component={PrivateAccounts}
            />
            {/* Invoices */}
            <ProtectedRoute
              exact
              path="/invoices/view/:id"
              component={InvoiceDetail}
            />
            <ProtectedRoute
              exact
              path="/invoices/:id"
              component={InvoiceForm}
            />
            <ProtectedRoute
              path="/invoices/:id/edit"
              component={InvoiceEditForm}
            />
            <ProtectedRoute path="/invoices" component={Invoices} />
            {/* PDC Received */}
            <ProtectedRoute
              exact
              path="/pdc-cheques/received/view/:id"
              component={ReceivedChequeDetail}
            />
            <ProtectedRoute
              exact
              path="/pdc-cheques/received/:id"
              component={ReceivedChequeForm}
            />
            <ProtectedRoute
              path="/pdc-cheques/received/:id/edit"
              component={ReceivedChequeEditForm}
            />
            <ProtectedRoute path="/pdc-cheques/received" component={Cheques} />
            {/* PDC Received */}
            <ProtectedRoute
              exact
              path="/pdc-cheques/paid/view/:id"
              component={PaidChequeDetail}
            />
            <ProtectedRoute
              exact
              path="/pdc-cheques/paid/:id"
              component={PaidChequeForm}
            />
            <ProtectedRoute
              path="/pdc-cheques/paid/:id/edit"
              component={PaidChequeEditForm}
            />
            <ProtectedRoute path="/pdc-cheques/paid" component={PCheques} />
            {/* accounts ledgers type routes */}
            <ProtectedRoute
              exact
              path="/ledgers-types/:id"
              component={LedgerTypeForm}
            />
            <ProtectedRoute
              exact
              path="/ledgers-types/:id/edit"
              component={LedgerTypeEditForm}
            />
            <ProtectedRoute
              exact
              path="/ledgers-types"
              component={LedgerTypes}
            />
            {/* private accounts ledgers type routes */}
            <ProtectedRoute
              exact
              path="/private-ledgers-types/:id"
              component={PrivateLedgerTypeForm}
            />
            <ProtectedRoute
              exact
              path="/private-ledgers-types/:id/edit"
              component={PrivateLedgerTypeEditForm}
            />
            <ProtectedRoute
              exact
              path="/private-ledgers-types"
              component={PrivateLedgerTypes}
            />
            {/* reports routes */}
            <ProtectedRoute
              exact
              path="/report/salary"
              component={SalaryReport}
            />
            <ProtectedRoute
              exact
              path="/report/project-salary"
              component={ProjectSalaryReport}
            />
            <ProtectedRoute
              exact
              path="/report/income"
              component={IncomeReport}
            />
            <ProtectedRoute
              exact
              path="/report/scrap"
              component={ScrapReport}
            />
            <ProtectedRoute exact path="/reports" component={Reports} />

            <ProtectedRoute exact path="/report/jv" component={JVReport} />
            <ProtectedRoute
              exact
              path="/report/vehicle"
              component={VehicleReport}
            />
            <ProtectedRoute
              exact
              path="/report/generate-receiveable-report"
              component={ReceiveableReport}
            />
            <ProtectedRoute
              exact
              path="/report/generate-payable-report"
              component={PayableReport}
            />
            <ProtectedRoute exact path="/report/visa" component={VisaReport} />
            <ProtectedRoute exact path="/report/yard" component={YardReport} />
            <ProtectedRoute exact path="/report/room" component={RoomReport} />
            <ProtectedRoute
              exact
              path="/report/general-ledger"
              component={GeneralLedgerReport}
            />
            <ProtectedRoute
              exact
              path="/report/passport-inout"
              component={PassportInOutReport}
            />
            <ProtectedRoute
              exact
              path="/report/invoices"
              component={InvoicesReport}
            />
            <ProtectedRoute
              exact
              path="/report/projects"
              component={ProjectsReport}
            />
            <ProtectedRoute
              exact
              path="/report/cheques/pdc-paid"
              component={PDCPaidReport}
            />
            <ProtectedRoute
              exact
              path="/report/cheques/pdc-received"
              component={PDCReceivedReport}
            />
            <ProtectedRoute
              exact
              path="/report/expiry/vehicle"
              component={VehicleExpiryReport}
            />
            <ProtectedRoute
              exact
              path="/report/documents-expiry"
              component={DocumentsExpiryReport}
            />
            <ProtectedRoute
              exact
              path="/report/expiry/visa"
              component={VisaExpiryReport}
            />
            <ProtectedRoute
              exact
              path="/report/expiry/passport"
              component={PassportExpiryReport}
            />
            <ProtectedRoute
              exact
              path="/general-ledger-entry"
              component={GeneralLedgerEntry}
            />
            {/* salaries routes */}
            <ProtectedRoute
              exact
              path="/salaries/view/:id"
              component={SalaryDetail}
            />
            <ProtectedRoute exact path="/salaries/:id" component={SalaryForm} />
            <ProtectedRoute
              path="/salaries/:id/edit"
              component={SalaryEditForm}
            />
            <ProtectedRoute path="/salaries" component={Salaries} />
            {/* users routes */}
            <ProtectedRoute exact path="/users/:id" component={UserForm} />
            <ProtectedRoute path="/users/:id/edit" component={UserEditForm} />
            <ProtectedRoute path="/users" component={Users} />
            {/* company documents */}
            <ProtectedRoute
              exact
              path="/company-documents/:id"
              component={CompanyDocumentForm}
            />
            <ProtectedRoute
              exact
              path="/company-documents/:id/edit"
              component={CompanyDocumentEditForm}
            />
            <ProtectedRoute
              path="/company-documents"
              component={CompanyDocuments}
            />
            {/* banks accounts */}
            <ProtectedRoute
              exact
              path="/banks-accounts/:id"
              component={BankForm}
            />
            <ProtectedRoute
              path="/banks-accounts/:id/edit"
              component={BankEditForm}
            />
            <ProtectedRoute path="/banks-accounts" component={Banks} />
            {/* visas accounts */}
            <ProtectedRoute
              exact
              path="/visas-accounts/:id/document/new/"
              component={VisaDocumentForm}
            />
            <ProtectedRoute
              exact
              path="/visas-accounts/:id/document/new/:ledger"
              component={VisaLedgerDocumentForm}
            />
            <ProtectedRoute
              exact
              path="/visas-ledgers/:id/edit"
              component={VisaLedgerEditForm}
            />
            <ProtectedRoute
              exact
              path="/visas-documents/:id/edit"
              component={VisaDocumentEditForm}
            />
            <ProtectedRoute
              exact
              path="/visas-accounts/view/:id"
              component={VisaDetail}
            />
            <ProtectedRoute
              exact
              path="/visas-accounts/in-out/:id"
              component={VisaInOutDetail}
            />
            <ProtectedRoute
              exact
              path="/visas-accounts/:id"
              component={VisaForm}
            />
            <ProtectedRoute
              exact
              path="/visas-accounts/:id/edit"
              component={VisaEditForm}
            />
            <ProtectedRoute exact path="/visas-accounts" component={Visas} />
            {/* yards accounts */}
            <ProtectedRoute
              exact
              path="/yards-ledgers/:id/edit"
              component={YardLedgerEditForm}
            />
            <ProtectedRoute
              exact
              path="/yards-accounts/:id"
              component={YardForm}
            />
            <ProtectedRoute
              path="/yards-accounts/:id/edit"
              component={YardEditForm}
            />
            <ProtectedRoute path="/yards-accounts" component={Yards} />
            {/* vehicles accounts */}
            <ProtectedRoute
              exact
              path="/vehicles-accounts/:id/document/new/"
              component={VehicleDocumentForm}
            />
            <ProtectedRoute
              exact
              path="/vehicles-accounts/:id/document/new/:ledger"
              component={VehicleLedgerDocumentForm}
            />
            <ProtectedRoute
              exact
              path="/vehicles-ledgers/:id/edit"
              component={VehicleLedgerEditForm}
            />
            <ProtectedRoute
              exact
              path="/vehicles-documents/:id/edit"
              component={VehicleDocumentEditForm}
            />
            <ProtectedRoute
              exact
              path="/vehicles-accounts/view/:id"
              component={VehicleDetail}
            />
            <ProtectedRoute
              exact
              path="/vehicles-accounts/:id"
              component={VehicleForm}
            />
            <ProtectedRoute
              exact
              path="/vehicles-accounts/:id/edit"
              component={VehicleEditForm}
            />
            <ProtectedRoute path="/vehicles-accounts" component={Vehicles} />
            {/* project accounts */}
            <ProtectedRoute
              exact
              path="/projects-ledgers/:id/edit"
              component={ProjectLedgerEditForm}
            />
            <ProtectedRoute
              exact
              path="/projects-accounts/view/:id"
              component={ProjectDetail}
            />
            <ProtectedRoute
              exact
              path="/projects/:id/document/new/:ledger"
              component={ProjectLedgerDocumentForm}
            />
            <ProtectedRoute
              exact
              path="/visas-accounts/:id/document/new/"
              component={VisaDocumentForm}
            />
            <ProtectedRoute
              exact
              path="/visas-documents/:id/edit"
              component={VisaDocumentEditForm}
            />
            {/* <ProtectedRoute
              exact
              path="/rooms-accounts/:id/document/new/:ledger"
              component={RoomLedgerDocumentForm}
            /> */}
            <ProtectedRoute
              exact
              path="/projects-accounts/:id/document/new/"
              component={ProjectLedgerDocumentForm}
            />
            <ProtectedRoute
              exact
              path="/projects-documents/:id/edit"
              component={ProjectDocumentEditForm}
            />
            <ProtectedRoute
              exact
              path="/projects-accounts/:id"
              component={ProjectForm}
            />
            <ProtectedRoute
              path="/projects-accounts/:id/edit"
              component={ProjectEditForm}
            />
            <ProtectedRoute path="/projects-accounts" component={Projects} />
            {/* rooms accounts */}
            <ProtectedRoute
              exact
              path="/rooms-ledgers/:id/edit"
              component={RoomLedgerEditForm}
            />
            <ProtectedRoute
              exact
              path="/rooms-accounts/view/:id"
              component={RoomDetail}
            />
            <ProtectedRoute
              exact
              path="/rooms-accounts/:id/document/new/:ledger"
              component={RoomLedgerDocumentForm}
            />
            <ProtectedRoute
              exact
              path="/rooms-accounts/:id"
              component={RoomForm}
            />
            <ProtectedRoute
              path="/rooms-accounts/:id/edit"
              component={RoomEditForm}
            />
            <ProtectedRoute path="/rooms-accounts" component={Rooms} />
            {/* yards ledgers type routes */}
            <ProtectedRoute
              exact
              path="/yards-ledgers-types/:id"
              component={YardTypeForm}
            />
            <ProtectedRoute
              path="/yards-ledgers-types/:id/edit"
              component={YardTypeEditForm}
            />
            <ProtectedRoute path="/yards-ledgers-types" component={YardTypes} />
            {/* visas ledgers type routes */}
            <ProtectedRoute
              exact
              path="/visas-ledgers-types/:id"
              component={VisaTypeForm}
            />
            <ProtectedRoute
              path="/visas-ledgers-types/:id/edit"
              component={VisaTypeEditForm}
            />
            <ProtectedRoute path="/visas-ledgers-types" component={VisaTypes} />
            {/* vehicles ledgers type routes */}
            <ProtectedRoute
              exact
              path="/vehicles-ledgers-types/:id"
              component={VehicleTypeForm}
            />
            <ProtectedRoute
              path="/vehicles-ledgers-types/:id/edit"
              component={VehicleTypeEditForm}
            />
            <ProtectedRoute
              path="/vehicles-ledgers-types"
              component={VehicleTypes}
            />
            {/* rooms ledgers type routes */}
            <ProtectedRoute
              exact
              path="/rooms-ledgers-types/:id"
              component={RoomTypeForm}
            />
            <ProtectedRoute
              path="/rooms-ledgers-types/:id/edit"
              component={RoomTypeEditForm}
            />
            <ProtectedRoute path="/rooms-ledgers-types" component={RoomTypes} />
            {/* companies routes */}
            <ProtectedRoute
              exact
              path="/companies/:id/manager-edit/:uid"
              component={CompanyEditManagerForm}
            />
            <ProtectedRoute
              exact
              path="/companies/:id"
              component={CompanyForm}
            />
            <ProtectedRoute
              path="/companies/:id/edit"
              component={CompanyEditForm}
            />
            {/* contacts */}
            <ProtectedRoute
              exact
              path="/web/contacts/:id"
              component={ContactForm}
            />
            <ProtectedRoute
              path="/web/contacts/:id/edit"
              component={ContactEditForm}
            />
            <ProtectedRoute path="/web/contacts" component={Contacts} />
            {/* tours */}
            <ProtectedRoute exact path="/web/tours/:id" component={TourForm} />
            <ProtectedRoute
              path="/web/tours/:id/edit"
              component={TourEditForm}
            />
            <ProtectedRoute path="/web/tours" component={Tours} />
            {/* contributers */}
            <ProtectedRoute
              exact
              path="/web/contributer/:id"
              component={ContributerForm}
            />
            <ProtectedRoute
              path="/web/contributers/:id/edit"
              component={ContributerEditForm}
            />
            <ProtectedRoute path="/web/contributers" component={Contributers} />
            {/* news */}
            <ProtectedRoute exact path="/web/news/:id" component={NewsForm} />
            <ProtectedRoute
              path="/web/news/:id/edit"
              component={NewsEditForm}
            />
            <ProtectedRoute path="/web/news" component={News} />
            {/* pages */}
            <ProtectedRoute exact path="/web/page/:id" component={PageForm} />
            <ProtectedRoute
              path="/web/page/:id/edit"
              component={PageEditForm}
            />
            <ProtectedRoute path="/web/pages" component={Pages} />
            {/* villages */}
            <ProtectedRoute
              exact
              path="/web/village/:id"
              component={VillageForm}
            />
            <ProtectedRoute
              path="/web/village/:id/edit"
              component={VillageEditForm}
            />
            <ProtectedRoute path="/web/villages" component={Villages} />

            {/* photos */}
            <ProtectedRoute exact path="/web/photo/:id" component={PhotoForm} />
            <ProtectedRoute
              path="/web/photo/:id/edit"
              component={PhotoEditForm}
            />
            <ProtectedRoute path="/web/photos" component={Photos} />
            {/* teachers */}
            <ProtectedRoute
              exact
              path="/web/teacher/:id"
              component={TeacherForm}
            />
            <ProtectedRoute
              path="/web/teacher/:id/edit"
              component={TeacherEditForm}
            />
            <ProtectedRoute path="/web/teachers" component={Teachers} />
            <ProtectedRoute path="/companies" component={Companies} />
            <Route path="/login" component={LoginForm} />
            <Route path="/logout" component={Logout} />
            <Route path="/not-found" component={NotFound} />
          </Switch>
        </Container>
      </React.Fragment>
    );
  }
}

export default App;
